<template>
<v-flex class="elevation-10"  >
  <v-card v-for="(item, index) in TableLines" :key="`grp` + item.id">
      <groupHeader :groupTitle="item.title" :id="`grp` + item.id"></groupHeader>
      <v-list subheader v-for="(params, index) in item.params" :key="`g` + item.id + `p_` + params.id" :title="params.description" class="ma-0 pa-0">
      <lineInfo  :title="params.title"  v-model="params.value" :grpId="item.id" :dimension="params.dimension" :paramValue="(item.refresh === true) ? $store.getters.getStatusParamValue('0', params.id) : params.value" :params="params"></lineInfo>
      </v-list>
  </v-card>
</v-flex>
</template>

<script>

import groupHeader from './groupHeader'
import lineInfo from './lineInfo'
import lineStatus from './lineStatus'
import Vue from 'vue'
// import VueResource from 'vue-resource'

// Vue.use(VueResource)

export default {
  name: 'deviceInfo',
  components: {
    groupHeader,
    lineInfo,
    lineStatus
  },
  data () {
    return {
      obj: {
        /* lines: [
          { paramTitle: 'Device model',
            paramValue: 'tdx550',
            paramRefresh: false,
            paramID: 10
          },
          { paramTitle: 'Serial number',
            paramValue: 'tdx550AA12345678',
            paramRefresh: false,
            paramID: 20
          }
        ], */
        lines: [],
        groupTitle: 'no title',
        groupBoxWidth: 400
      }
    }
  },
  computed: {
    getLineValue: function () {
      var This = this
      return this.obj.lines.map(function (line) {
        if (line.refresh) {
          if (line.refresh === true) return This.$store.getters.getStatusParamValue('0', line.id)
        }
        return line.value
      })
    },
    TableLines: function () {
      var newArr = []
      this.$store.getters.getActiveGroups.forEach(function(item) {
        if (!item.groups) 
          newArr.push(item)
      })
      return newArr
    }
  },
  methods: {
        getParameters: function (obj) {
      var Result = {}
      /* if (obj.cellWidth) Result.cellWidth = obj.cellWidth
      else Result.cellWidth = 150 */

      if (obj.inputWidth) Result.inputWidth = obj.inputWidth
      else Result.inputWidth = 100
      if (obj.textAlign) Result.textAlign = obj.textAlign
      if (obj.paddingLeft) Result.paddingLeft = obj.paddingLeft + 'px'

      Result.value = obj.value
      Result.label = obj.title;

      if (obj.type === 0) {       // Digital
        Result.type = 'Number'
        Result.name = obj.id
        Result.min = obj.min
        Result.max = obj.max
        Result.step = obj.step ? obj.step : 1
        Result.inputWidth -= 6
        if (obj.disabled) Result.disabled = obj.disabled
        if (obj.dimension) Result.dim = obj.dimension
      }
      if (obj.type === 1) {    // float
        // TODO - not supported yet
      }
      if (obj.type === 2) {  // Enumerate
        Result.type = 'Enumerate'
        Result.name = obj.id
        Result.selected = obj.value
        //console.log(Result.label)
        if(obj.options)
        {
          Result.options = []
          obj.options.forEach(option=>{
            var myoption={}
            myoption.text = option.title
            myoption.value = option.value
            myoption.disabled = option.disabled
            Result.options.push(myoption)
          });
        }
        if (obj.disabled) Result.disabled = obj.disabled
        if (obj.dimension) Result.dim = obj.dimension
      }
      if (obj.type === 3) {  // xml_Boolean
        Result.type = 'Checkbox'
        Result.name = obj.id
        if (obj.disabled) Result.disabled = obj.disabled
      }
      if (obj.type === 4) {  // xml_String
        Result.type = 'Text'
        Result.name = obj.id
        Result.value = obj.value
        if (obj.regex) Result.regex = obj.regex
        if (obj.disabled) Result.disabled = obj.disabled
        if (obj.dimension) Result.dim = obj.dimension
      }
      if (obj.type === 6) {  // xml_Info        
        Result.type = 'Text'
        Result.name = obj.id
        if (obj.dimension) Result.dim = obj.dimension
      }
      if (obj.type === 7) {  // Title
        Result.type = 'Title'
        Result.name = obj.id
      }
      if (obj.type === 100) 
      { // xml_Status
        Result.type = 'Status'
        Result.name = obj.id
        Result.value = obj.value
        Result.inputWidth -= 6
        if (obj.dimension) Result.dim = obj.dimension
      }
      return Result
    }
    /* getLineValue: function (line) {
      if (line.refresh) {
        if (line.refresh === true) return this.$store.getters.getStatusParamValue('0', line.id)
      }
      return line.value
    }, */
    // btnClick: function (params) {
    //   // window.menu.init('ddtopmenubar', 'topbar')
    //   this.$store.commit('showPrompt', {
    //     title: params.prompt.msgTitle,
    //     id: params.id,
    //     prompt: params.prompt.promptText,
    //     value: params.value,
    //     buttons: params.prompt.buttons,
    //     callback: this.getPromptResult,
    //     context: params
    //   })
    // },
    // getPromptResult: function (pressedButton, newStrings, context) {
    //   if (pressedButton === 1) { // Paspaudė OK
    //     this.$http.get('ajax.cgi', {
    //       params: {
    //         cmd: 'setMainInfo',
    //         param: context.id,
    //         value: newStrings[Object.keys(newStrings)[0]]
    //       }
    //     }).then(function (response) {
    //       if (response.data.status === 0) {  // viskas gerai.
    //         this.obj.lines.forEach(function (element) {
    //           if (context.id === element.id) {
    //             element.value = newStrings[Object.keys(newStrings)[0]]
    //           }
    //         })
    //         this.$store.commit('closeModal')
    //       } else {
    //         this.$store.commit('setModalError', response.data.message)
    //         if (response.data.invalidFields) {
    //           this.$store.commit('setModalLineField', { line: 0, field: 'wrongField', value: true })
    //         }
    //       }
    //     })
    //   } else {
    //     this.$store.commit('closeModal')
    //   }
    //   /* this.$store.commit('setModalLineField', {
    //     line: 0,
    //     field: 'wrongField',
    //     value: (pressedButton === 1)
    //   })
    //   this.$store.commit('setModalError', (pressedButton === 1) ? 'Didelė klaida!' : '')  */
    //   // alert(Object.keys(newStrings)[0])
    // }
  },
  beforeMount: function () {
  //   this.$http.get('ajax.cgi', {
  //     params: {
  //       cmd: 'getMainInfo'
  //     }
  //   }).then(function (response) {
  //     this.obj = response.data
  //     if (this.obj.lines) {
  //       var P = {}
  //       this.obj.lines.forEach(function (line) {
  //         if (line.refresh === true) {
  //           P[line.id] = line.value
  //         }
  //       })
  //       if (Object.getOwnPropertyNames(P).length > 0) {
  //         this.$store.commit('addStatusParams', { id: '0', params: P })
  //       }
  //     }
  //   },
  //   function (error) {
  //     console.log(error.statusText)
  //   }
  // )
  }
}
</script>
